module.exports = __webpack_public_path__ + "static/media/legz.5bae54f5.gif";